export const feedbackLimit = 3;
